<template>
  <MongoDataTable
    ref="table"
    :headers="new Array(5).fill({})"
    itemKey="key"
    :dataTableProps="{ expand: true }"
    :insertable="false"
    :editable="false"
    :deletable="false"
    :selectable="false"
    :refreshable="false"
    :filterable="false"
    :columnSelectable="false"
    :sortable="false"
    :rowsPerPage="-1"
    :countable="false"
    containerClass="elevation-0"
    :hideToolbar="true"
    :hideHeaders="false"
    :hideFooters="false"
    :onTableItems="v => v"
    :onRefresh="() => {}"
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th class="column text-xs-center" width="100">
          <div><v-checkbox v-model="props.scope.selectAll" @change="toggleCheckAllBots(props.scope.selectAll)"></v-checkbox></div>
        </th>
        <th class="column text-xs-center" width="100" @click="changeSort('isActive')">
          <div>Active</div>
        </th>
        <th class="column text-xs-center" width="100" @click="changeSort('exchange')">
          <div>Exchange</div>
        </th>
        <th class="column text-xs-center" width="100" @click="changeSort('accountId')">
          <div>Account Id</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('type')">
          <div>Type</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('base')">
          <div>Base</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('quote')">
          <div>Quote</div>
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr class="disable-hover-color cursor-pointer">
        <td class="text-xs-center">
          <v-checkbox v-model="props.scope.item.select"></v-checkbox>
        </td>
        <td class="text-xs-center">
          {{props.scope.item.isActive}}
        </td>
        <td class="text-xs-center">
          {{props.scope.item.exchange}}
        </td>
        <td class="text-xs-center">
          {{props.scope.item.accountId}}
        </td>
        <td>
          {{props.scope.item.type}}
        </td>
        <td>
          {{props.scope.item.base}}
        </td>
        <td>
          {{props.scope.item.quote}}
        </td>
      </tr>
    </template>
  </MongoDataTable>
</template>

<script>
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable'
import MongoDataTableItemField from '../../components/mongo-datatable/MongoDataTableItemField'
import { titleText } from '../../libs/utils'

export default {
  props: {
    ready: { type: Boolean, required: false, default: true },
    loading: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
    items: { type: Array, required: true }
  },
  components: {
    MongoDataTable,
    MongoDataTableItemField
  },
  watch: {
    loading: {
      immediate: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    },
    items: {
      deep: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    }
  },
  methods: {
    titleText,
    async refresh () {
      const table = this.$refs.table
      table.setLoader(this.loading)
      if (!this.loading) {
        table.setItems(this.items, true)
      }
    },
    async toggleCheckAllBots(select) {
      this.items.map(c => c.select = select)
      this.refresh()
    },
    changeSort (column) {
      this.$refs.table.changeSort(column)
    }
  }
}
</script>
